import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph, Block } from '@uncinc/react-drupal-core';

import {
  BLOCK_NEWSLETTER_BLOCK_ID,
} from '../../../config/constants';

import './style.scss';

const NodeOverviewPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeOverviewPage');
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>

      <Container>
        <div className="NodeOverviewPage__hero">
          <h1 itemProp="name">{title}</h1>
          {body ? (
            <WysiwygField
              property="schema:text"
              html={body}
            />
          ) : null}
        </div>
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}

      {/* Newsletter block */}
      <Block
        id={BLOCK_NEWSLETTER_BLOCK_ID}
      />

    </article>
  );
};

export default NodeOverviewPage;
